import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { InfoBlock } from '@picsio/ui';
import cn from 'classnames';

import styles from './styles.module.scss';

const PromotionalBlock = (props) => {
  const {
    className, children, icon, title, description, isIconAvailable, onCloseCallback, onClickCallback,
  } = props;

  const onClick = useCallback((e) => {
    e.stopPropagation();

    if (!onClickCallback) return;

    onClickCallback();
  }, [onClickCallback]);

  const getIcon = useCallback(() => (icon ? () => icon : undefined), [icon]);

  const onClose = useCallback((e) => {
    e.stopPropagation();

    onCloseCallback();
  }, [onCloseCallback]);

  const onCloseHandler = useMemo(() => (onCloseCallback ? onClose : undefined), [onCloseCallback, onClose]);

  return (
    <InfoBlock maxWidth={700} icon={getIcon()} className={cn(styles.promo, className)} isIconAvailable={isIconAvailable} onClick={onClick} onClose={onCloseHandler}>
      <If condition={title}>
        <span className={styles.promoTitle}>{title}</span>
      </If>
      <If condition={description}>
        <span className={styles.promoDescription}>{description}</span>
      </If>
      <If condition={children}>
        <div>{children}</div>
      </If>
    </InfoBlock>
  );
};

PromotionalBlock.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element]),
  description: PropTypes.string,
  isIconAvailable: PropTypes.bool,
  icon: PropTypes.element,
  title: PropTypes.string,
  onCloseCallback: PropTypes.func,
  onClickCallback: PropTypes.func,
};

PromotionalBlock.defaultProps = {
  className: '',
  children: null,
  description: '',
  isIconAvailable: true,
  icon: undefined,
  title: '',
  onCloseCallback: undefined,
  onClickCallback: undefined,
};

export default PromotionalBlock;
